import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { ISgpDetail, ISgpSearch } from "./sgpTypes";


class SgpService {
    async page(searchVo: ISgpSearch, config: object = {}) {
        const apiUrl = "/gtm/statistical/contractProfitAnalysis";
        return await httpRequest.post<IPage<ISgpDetail>>(apiUrl, searchVo, config);
    }
    //导出
    async export(searchVo: ISgpSearch) {
        const appPageUrl = "/gtm/statistical/contractProfitAnalysis/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }

}

export const sgpService = new SgpService();
